import { getJrnDefaultComponent } from '../getJrn/getJrnDefaultComponent.js'
import getJbcController from './getJbcController.js'
import _module from 'module.js'
import _ from 'lodash'

let getJbcComponent = _.cloneDeep(getJrnDefaultComponent)
getJbcComponent.controller = getJbcController

_module.component('getJbc', getJbcComponent)
